import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { combineLatest, Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';

import { AuthenticationService } from '@app/authentication/authentication.service';
import { environment } from '@env';
import { User } from '@shared/models/User';

@Injectable({ providedIn: 'root' })
export class FeatureFlagService {

    private static readonly BASE_URL = `${environment.featureToggleUrl}/api/feature-toggle`;

    private featureMap = new Map<string, Observable<boolean>>();

    constructor(
        private http: HttpClient,
        private auth: AuthenticationService,
    ) { }

    public hasAccessToFeature(feature: string): Observable<boolean> {
        const cnpj = this.cnpj;
        const key = `${cnpj}:${feature}`;
        if (this.featureMap.has(key)) {
            return this.featureMap.get(key);
        }
        if (!cnpj || !environment.featureToggleUrl) {
            return of(false);
        }

        const params = new HttpParams()
            .set('cnpj', cnpj)
            .set('nameFeature', feature);
        const headers = this.auth.getAuthorizationHeaders();

        const request$ = this.http
            .get<boolean>(FeatureFlagService.BASE_URL, { params, headers })
            .pipe(
                map(enabled => !!enabled),
                catchError(() => of(false)),
                shareReplay(1),
            );
        this.featureMap.set(key, request$);
        return request$;
    }

    public hasAnyFeature(...features: string[]): Observable<boolean> {
        return combineLatest(features.map(feature => this.hasAccessToFeature(feature)))
            .pipe(map(results => results.some(Boolean)));
    }

    public clearCache() {
        this.featureMap.clear();
    }

    private get cnpj(): string {
        return User.fromLocalStorage()?.organization?.cnpj;
    }

    public get isTopHeroTareffa() {
        return this.hasAccessToFeature('tareffa.top-heroes');
    }

}
